module.exports = __webpack_public_path__ + "static/media/Activities.26deb15a.png";